module.exports = __webpack_public_path__ + "static/media/videochamada-encerrada.41230135.png";